window.addEventListener('load', () => {
  console.log('Loaded custom JS');
});


// WEBPACK FOOTER //
// ./src/js/custom.js